export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";